import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=8d3c23f4&"
import script from "./FormTextarea.vue?vue&type=script&lang=ts&"
export * from "./FormTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d3c23f4')) {
      api.createRecord('8d3c23f4', component.options)
    } else {
      api.reload('8d3c23f4', component.options)
    }
    module.hot.accept("./FormTextarea.vue?vue&type=template&id=8d3c23f4&", function () {
      api.rerender('8d3c23f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/form/FormTextarea.vue"
export default component.exports